export const validateCardNumber = (cardNumber) => {
    // Accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(cardNumber)) {
        return false;
    }
    const value = cardNumber.replace(/\D/g, '');
    // The Luhn Algorithm.
    let sum = 0;
    let isEvenDigit = false;
    for (let i = value.length - 1; i >= 0; i--) {
        const digitChar = value.charAt(i);
        let digit = parseInt(digitChar, 10);
        if (isEvenDigit && (digit *= 2) > 9) {
            digit -= 9;
        }
        sum += digit;
        isEvenDigit = !isEvenDigit;
    }
    const isValid = sum % 10 === 0;
    return isValid;
};
//# sourceMappingURL=validate-card-number.js.map